import { parseAddress } from '@libraries/helpers';
import { CreateProjectPayload } from '../../state';
import { OwnerData } from './eligible-funds.model';

const HVAC = {
  display_name: 'HVAC',
  file_path: '/assets/images/hvac.svg',
};
const SOLAR = {
  display_name: 'Solar',
  file_path: '/assets/images/solar.svg',
};
const WINDOWS_AND_DOORS = {
  display_name: 'Windows & Doors',
  file_path: '/assets/images/windows-and-doors.svg',
};
const ROOFING = {
  display_name: 'Roofing',
  file_path: '/assets/images/roofing.svg',
};
const HURRICANE_PROTECTION = {
  display_name: 'Hurricane Protection',
  file_path: '/assets/images/hurricane-protection.svg',
};

export const StatesWithImprovements = {
  CA: {
    [HVAC.display_name]: [ROOFING, WINDOWS_AND_DOORS, SOLAR],
    [WINDOWS_AND_DOORS.display_name]: [ROOFING, HVAC, SOLAR],
    [SOLAR.display_name]: [WINDOWS_AND_DOORS, ROOFING, HVAC],
    [ROOFING.display_name]: [SOLAR, HVAC, WINDOWS_AND_DOORS],
    default: [ROOFING, HVAC, WINDOWS_AND_DOORS],
  },

  MO: {
    [HVAC.display_name]: [ROOFING, WINDOWS_AND_DOORS, SOLAR],
    [WINDOWS_AND_DOORS.display_name]: [ROOFING, HVAC, SOLAR],
    [SOLAR.display_name]: [WINDOWS_AND_DOORS, ROOFING, HVAC],
    [ROOFING.display_name]: [SOLAR, HVAC, WINDOWS_AND_DOORS],
    default: [ROOFING, HVAC, WINDOWS_AND_DOORS],
  },

  FL: {
    [HURRICANE_PROTECTION.display_name]: [WINDOWS_AND_DOORS, ROOFING, SOLAR],
    [WINDOWS_AND_DOORS.display_name]: [HURRICANE_PROTECTION, HVAC, ROOFING],
    [SOLAR.display_name]: [HURRICANE_PROTECTION, HVAC, WINDOWS_AND_DOORS],
    [ROOFING.display_name]: [HURRICANE_PROTECTION, SOLAR, WINDOWS_AND_DOORS],
    [HVAC.display_name]: [HURRICANE_PROTECTION, WINDOWS_AND_DOORS, ROOFING],
    default: [HURRICANE_PROTECTION, HVAC, WINDOWS_AND_DOORS],
  },
};

export function decodeQueryParams(queryParams: OwnerData) {
  const encodedObj = { ...queryParams };
  encodedObj.address = window.atob(encodedObj.address);

  return encodedObj;
}

export function constructCreateProjectPayload(data) {
  const { email, improvements, timeframes: how_soon } = data;
  const parsedAddress = parseAddress(data.address);
  const { line_1: address, line_2, city, state, zipcode } = parsedAddress;

  const payload: CreateProjectPayload = {
    metadata: { how_soon, improvements },
    property_search: { address, line_2, city, state, zipcode },
    user: { email },
  };

  return payload;
}
